import React from 'react';
import classNames, { Argument } from 'classnames';

import Icon, { ICONS, COLORS } from './icon';

interface ButtonBackProps {
	onClick: () => void;
	moreClassNames?: Argument;
	noPadding?: boolean;
}

export default function ButtonBack(props: ButtonBackProps) {
	const padding = props.noPadding ? '' : 'padding-left-24px';
	return (
		<button
			className={classNames(
				'button-back transparent',
				padding,
				props.moreClassNames,
			)}
			onClick={props.onClick}
		>
			<Icon name={ICONS.ARROW_LEFT} color={COLORS.DARK_GRAY_2} size={16} />
		</button>
	);
}